export const API_MESSAGING_ROUTES = Object.freeze({
  CHANNEL_IDS: '/messaging/channel-ids',
});
